import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import {FormControl, FormControlLabel} from 'material-ui/Form'
import {Checkbox} from 'material-ui'
import classNames from 'classnames'

const styles = theme => ({
  Container: {
    padding: '0 14px',
    transition: 'background-color 500ms',
  },
  Error: {
    backgroundColor: 'rgba(255, 0, 0, 0.4)',
  },
})

const Check = ({classes, text, checked, onChange = () => {}, error = false, style = {}}) => (
  <FormControl className={classNames(classes.Container, {[classes.Error]: error})} style={style}>
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          onChange={onChange}
          color={'primary'}
        />
      }
      label={text}
    />
  </FormControl>
)

Check.propTypes = {
  text: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  error: PropTypes.bool,
  style: PropTypes.object,
}

export default withStyles(styles, {withTheme: true})(Check)



// WEBPACK FOOTER //
// ./src/sections/flow/components/check.jsx